<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    created() {
      // 在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem('store')) {
        this.$store.replaceState(
          Object.assign({},
            this.$store.state,
            JSON.parse(sessionStorage.getItem('store'))
          )
        )
      }

      if(this.isMobile()) {
        // alert("移动端");
        // this.$router.replace('/pc_index');
        window.location.href = "http://studym.edujgz.com"
      }

      // 在页面刷新时将vuex里的信息保存到sessionStorage里
      // beforeunload事件在页面刷新时先触发
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      })
    },
    methods: {
      // 添加判断方法
      isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        return flag;
       }
    }
  }
</script>

<style>
  body {
    padding: 0;
    margin: 0 auto;
    font-size: 16px;
    background: #f8f8f8;
    color: #333;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  li,
  ol,
  ul {
    list-style: none;
  }

  h3,
  h4 {
    margin: 0;
  }

  a {
    text-decoration: none;
    outline: none;
  }

  p {
    margin: 0;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
  }

  .clearfix:after {
    content: "";
    display: block;
    clear: both;
  }

  .fl {
    float: left;
  }

  .fr {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue